<template>
  <el-select
    v-model="izbranItem"
    v-if="items !== null && (items.length > 1 || !hideIfOnlyOne)"
    class="velikost-izbirnika-strank"
    :placeholder="placeholder"
    :disabled="disabled"
    :no-data-text="noDataText"
  >
    <el-option v-for="data in items"
               :key="data.value"
               :label="data.label"
               :value="data.value">
    </el-option>
  </el-select>
</template>

<script>
import {Select, Option} from 'element-ui'

export default {
  name: 'SimpleIzbirnik',
  components: {
    [Option.name]: Option,
    [Select.name]: Select
  },
  emits: ['input'],
  props: {
    seznam: {
      type: Array,
      default: null
    },
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideIfOnlyOne: {
      type: Boolean,
      default: false
    },
    izberiPrvo: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Izberite stranko'
    },
    noDataText: {
      type: String,
      default: 'Nimate povezanih naročnin'
    }
  },
  data () {
    return {
      items: null
    }
  },
  computed: {
    izbranItem: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    seznam: {
      immediate: true,
      handler (val) {
        let tmpItems = []
        let valueFound = false
        if (Array.isArray(val)) {
          val.forEach(item => {
            if (this.value !== null && this.value === item.value) {
              valueFound = true
            }
            if (item.value != null && item.label != null) {
              tmpItems.push(item)
            }
          })
        }
        this.items = tmpItems
        if (this.items.length > 0 && (this.value === null || (this.value !== null && !valueFound && this.izberiPrvo))) {
          this.izbranItem = this.items[0].value
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GlobalneKomponente/SimpleIzbirnik.vue